export default __webpack_public_path__ + "static/media/VT-800.ec35a2b2.png";